export const ChatMock = () => {
  return (
    <svg
      width="232"
      height="117"
      viewBox="0 0 232 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.599258"
        y="99.36"
        width="230.28"
        height="17.28"
        rx="1.64"
        fill="#F9F7F3"
      />
      <rect
        x="0.599258"
        y="99.36"
        width="230.28"
        height="17.28"
        rx="1.64"
        stroke="#B5B2AA"
        strokeWidth="0.72"
      />
      <path
        d="M227.445 107.999L216.47 102.803L217.259 107.278L220.359 108.736V107.665L218.126 106.614L217.749 104.478L225.183 107.999L217.749 111.52L218.228 108.803L217.318 108.377L216.47 113.196L227.445 107.999Z"
        fill="#B5B2AA"
      />
      <path
        d="M31.2607 8.32422C31.2607 5.01051 33.947 2.32422 37.2607 2.32422H152.261C155.574 2.32422 158.261 5.01051 158.261 8.32422V16.3242C158.261 19.6379 155.574 22.3242 152.261 22.3242H31.2607V8.32422Z"
        fill="#FBDCC5"
      />
      <rect
        x="37.4634"
        y="10.0723"
        width="114.406"
        height="4.64944"
        rx="2.32472"
        fill="#EBC09F"
      />
      <path
        d="M33 39.3262C33 36.0125 35.6863 33.3262 39 33.3262H225C228.314 33.3262 231 36.0125 231 39.3262V53.3262H39C35.6863 53.3262 33 50.6399 33 47.3262V39.3262Z"
        fill="#ECE9DF"
      />
      <rect
        x="39.2026"
        y="41.0742"
        width="183.66"
        height="4.64944"
        rx="2.32472"
        fill="#D7D3C9"
      />
      <circle cx="12.3985" cy="12.3985" r="12.3985" fill="#FDD0AE" />
      <path
        d="M11.1579 7.38982L9.74484 9.98184L9.51874 10.223L7.08873 11.7303L9.20091 13.0405L8.18305 13.9515L5.53125 12.3066V11.154L8.7474 9.15908L10.6176 5.72852H11.6982L13.5685 9.15908L16.7846 11.154V12.3066L13.5685 14.3016L11.6982 17.7321H10.6176L9.07179 14.8966L10.0436 14.0268L11.1579 16.0708L12.571 13.4788L12.7971 13.2376L15.2271 11.7303L12.7971 10.223L12.571 9.98184L11.1579 7.38982Z"
        fill="#816651"
      />
      <path
        d="M17.8967 16.5262L17.0961 15.0577L16.2955 16.5262L14.9188 17.3802L16.2955 18.2341L17.0961 19.7026L17.8967 18.2341L19.2734 17.3802L17.8967 16.5262Z"
        fill="#816651"
      />
    </svg>
  );
};
